module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Gansingen-16f5cbbac728f6ea87f3d4104aeaeb6b.svg";